import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { SyncStoreWriter } from '../shared/services/sync-store/sync-store-writer';
import { RegistrationStoreWriterService } from '../shared/services/data-store/registration-store-writer.service';
import { SyncStoreSaveData } from '../shared/storage/sync-store/update-data/sync-store-save-data';
import { SyncStoreUpdateAnimalWeighing } from '../shared/storage/sync-store/update-data/sync-store-update-animal-weighing';
import { SyncStoreUpdateBatchWeighing } from '../shared/storage/sync-store/update-data/sync-store-update-batch-weighing';
import { SyncStoreStateType } from '../shared/storage/sync-store/model/sync-store-state-type';
import { SyncStoreReader } from '../shared/services/sync-store/sync-store-reader';
import { SyncStoreUpdateRemoval } from '../shared/storage/sync-store/update-data/sync-store-update-removal';

@Injectable({
  providedIn: 'root'
})
export class SyncService {

  readonly SYNC_POST_URL = `${environment.api.baseUrl}/api/client/sync/syncpost`;
    constructor(
      private httpClient : HttpClient,
      private syncStoreReader: SyncStoreReader,
      private syncStoreWriter: SyncStoreWriter,
      private registrationStoreWriter: RegistrationStoreWriterService

    ) {}

    storeClear(): void {
      console.debug('Clearing store.');
      this.registrationStoreWriter.clear();
    }

    syncClear(): void {
      console.debug('Clearing sync store.');
      this.syncStoreWriter.clear();
    };

    async syncData(): Promise<boolean> {

      // Create a sample SyncUpdateAnimalWeighing object ?
      // TODO the below chunk of code is a temporary solution to test the sync functionality.
      /*
      const data = new Array<SyncUpdateAnimalWeighing>();
      data.push({
        id: new Uuidv7(),
        updateType: UpdateType.Create,
        lastKnownServerUpdate: {
          lastServerUpdate: new Date(),
          lastLocalUpdate: new Date(),
          lastEditedByUser: {
            userId: 'testuserId',
            name: 'Test User'
          },
        },
        batchWeighingId: new Uuidv7FromString('ebf7d37c-2c8f-42e5-b36b-d1c70441e2e7'),
        batchId: new Uuidv7FromString('29e964c1-4bb9-44a5-a34f-14203a4e5271'),
        sectionId: new Uuidv7FromString('3f04e05e-5b3c-4480-9b30-4bc9ac0c277b'),
        animalWeight: {
          animals: 10,
          weight: 150
        }
      });

      const syncData: SyncSaveData<SyncUpdateAnimalWeighing> = {
        id: new Uuidv7().asString(),
        time: new Date(),
        user: {
          userId: 'testuserId'
        },
        data: data
      };
      this.syncStoreWriter.persistAnimalWeighings(syncData);
      */
      // Get the animal weighings and batch weighings from the sync store
      const animalWeighings: SyncStoreSaveData<SyncStoreUpdateAnimalWeighing>[] = this.syncStoreReader.getAnimalWeighings();
      const batchWeighings: SyncStoreSaveData<SyncStoreUpdateBatchWeighing>[] = this.syncStoreReader.getBatchWeighing();
      const removals: SyncStoreSaveData<SyncStoreUpdateRemoval>[] = this.syncStoreReader.getRemovals();

      if (animalWeighings.length === 0 && batchWeighings.length === 0 && removals.length === 0) {
        console.debug('No data to sync. Sync store is empty.');
        return false;
      }

      console.debug(`Syncing ${animalWeighings.length} animal weighings, ${batchWeighings.length} batch weighings and ${removals.length} removals.`);

      const request: SyncStoreStateType = {
        animalWeighings: animalWeighings,
        batchWeighings: batchWeighings,
        removals: removals
      };

      //console.debug('Sync request:', JSON.stringify(request));

      return new Promise<boolean>((resolve, reject) => {
          this.httpClient.post(this.SYNC_POST_URL,
          request
        , { observe: 'response' })
                .subscribe({
                    next: (response) => {
                        if (response.status === 200) {
                            console.log('Sync successful. Clearing sync store.');
                            this.syncStoreWriter.clear();
                            resolve(true);
                            return

                        } else {
                            resolve(false);
                        }
                    },
                    error: (error) => reject(error)
                });
        });
    }
}
